import React from 'react';
import { Button } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { map, startCase } from 'lodash';

import { amountToUsd } from '@utils/currency';
import { InsurerLogo } from '@components/Feature/Insurer';
import { routeCarQuoteBuyNewPage } from '@components/CarQuoteBuyRoute';

import { selectCarQuoteComparePage } from './selector';
import { useCarQuotesResultPageParams } from '@components/CarQuoteResultPage';

const TableInsurer = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const params = useCarQuotesResultPageParams();
  const { carQuotes } = useSelector(selectCarQuoteComparePage);

  const handleClick = (carPlanId: number) => {
    navigate(routeCarQuoteBuyNewPage({ ...params, carPlanId }));
  };

  return (
    <tr className="shadow-sm sticky-top table-light">
      <th className="w-25 py-4" />
      {map(carQuotes, ({ carPlanId, insurer, totalPremium }) => (
        <th key={carPlanId} className="py-4">
          <div className="d-flex justify-content-center align-items-center mb-4" style={{ width: 200, height: 80 }}>
            <InsurerLogo insurer={insurer} rounded fluid className="h-100" />
          </div>

          <Button onClick={() => handleClick(carPlanId)} variant="primary" size="lg" style={{ width: 200 }}>
            <small>{startCase(t('common:buyNow'))}</small>
            <span className="fw-bold d-block">{amountToUsd(totalPremium)}</span>
          </Button>
        </th>
      ))}
    </tr>
  );
};

export { TableInsurer };
